import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    cart: [],
    totals: {},
    isCartLoading: false,
    isTotalsLoading: false,
    paymentMethods: {},
    shippingMethods: {},
    shippingAddress: {},
  },
  getters,
  actions,
  mutations,
};
